// HotChocolate offset-paging fields reject larger requests before resolvers run.
export const ADMIN_MAX_PAGE_SIZE = 50;
